import React from 'react';
import PropTypes from 'prop-types'

const Radio = (
  {
    name,
    onChange,
    value,
    label,
    disabled = false,
    checked = false,
    inputRef,
    ...inputProps
  }) => {

  const handleChange = (e) => {
    if(typeof onChange === 'function') {
      onChange(e.currentTarget.value)
    }
  }

  return (
    <label className='form-check form-check-custom form-check-solid mb-2 mt-2'>
      <input
        className='form-check-input'
        type='radio'
        name={name}
        onChange={handleChange}
        checked={checked}
        disabled={disabled}
        value={value}
        ref={inputRef}
        {...inputProps}
      />
      { label &&
        <span className='form-check-label'>
          {label}
        </span>
      }
    </label>
  )
}

Radio.defaultProps = {
  onChange: () => {}
}

Radio.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  value: PropTypes.string.isRequired,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
}

export default Radio;
